// extracted by mini-css-extract-plugin
export default {"discoverSubCategoriesStack":"DiscoverSubCategoriesPage_discoverSubCategoriesStack__gOOuv"};